import React from "react";

const SidebarLayout = ({ isSidebarExpanded, toggleSidebar }) => {
  return (
    <button
      className="p-2 bg-white border border-black hover:bg-black transition duration-300 flex items-center justify-center group"
      style={{ margin: "5px" }}
      onClick={toggleSidebar}
    >
      <svg
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`h-6 w-6 transform transition duration-300 stroke-black group-hover:stroke-white ${
          isSidebarExpanded ? "rotate-180" : "rotate-0"
        }`}
      >
        <line x1="4" y1="6" x2="14" y2="6" />
        <line x1="4" y1="18" x2="14" y2="18" />
        <path d="M4 12h17l-3 -3m0 6l3 -3" />
      </svg>
    </button>
  );
};

export default SidebarLayout;
